// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".csv-invitation-placeholder[data-v-e352281a] {\n  margin-top: 1.1rem;\n}\n.customModal[data-v-e352281a] {\n  max-height: calc(100vh - 285px);\n  overflow: auto;\n  margin-right: -10px;\n  padding-right: 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 100%;\n  margin-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
